import { render, staticRenderFns } from "./VariantSlider.vue?vue&type=template&id=2d493d44&scoped=true&"
import script from "./VariantSlider.vue?vue&type=script&lang=js&"
export * from "./VariantSlider.vue?vue&type=script&lang=js&"
import style0 from "./VariantSlider.vue?vue&type=style&index=0&id=2d493d44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d493d44",
  null
  
)

export default component.exports